export enum Roles {
    ADMIN = 'SuperAdmin',
    USER = 'user',
    MUNI_USER = 'muni',
    TOW_USER = 'tow',
}
